import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import Tabs from '@material-ui/core/Tabs';
import { withRouter } from 'react-router-dom'
import StyleSheet, { baseTheme } from 'styles'
import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';
import * as Icons from 'components/icons'

const MENU_COLLAPSE_AT_PX = 800;

export class Navigation extends Component {
  static propTypes = {
    breakpoint: PropTypes.number,
    history: PropTypes.object,
    currentPath: PropTypes.string,
    userInfo: PropTypes.any,
  }

  state = {
    drawerOpen: false
  }

  handleItemClick = (link) => {
    link.startsWith('http://') || link.startsWith('https://') ? window.location.href = link : this.props.history.push(link)
  }

  matchesPath(path, navItem) {
    if (navItem.props.requires === false)
      return false

    if (path.match(`^${navItem.props.match || navItem.props.link || '$'}`))
      return true

    const childMatches = React.Children.map(navItem.props.children, subItem => this.matchesPath(path, subItem))
    return !!childMatches && childMatches.some(v => v)
  }

  renderDesktop = () => {
    const {children} = this.props
    let activeItem = null
    let activeIndex = -1
    let count = 0
    const navItems = React.Children.map(children, navItem => {
      if (this.matchesPath(this.props.currentPath, navItem)) {
        activeItem = navItem
        activeIndex = count
      }
      count++
      return React.cloneElement(navItem, {onClick: this.handleItemClick})
    })

    let activeSubIndex = -1
    count = 0
    let subNavItems = null
    if (activeItem && activeItem.props.children) {
      subNavItems = React.Children.map(activeItem.props.children, navItem => {
        if (this.matchesPath(this.props.currentPath, navItem))
          activeSubIndex = count
        count++
        return React.cloneElement(navItem, {onClick: this.handleItemClick})
      })
    }

    return (
      <Fragment>
        <div className={styles.mainTabsContainer}>
          <Tabs className={styles.mainTabs} value={activeIndex}>
            {navItems}
          </Tabs>
          {this.props.userInfo}
        </div>
        {subNavItems &&
          <div className={styles.subTabsContainer}>
            <Tabs className={styles.subTabs} value={activeSubIndex}>
              {subNavItems}
            </Tabs>
          </div>
        }
      </Fragment>
    )
  }

  renderMobile = () => {
    return (
      <div className={styles.mainTabsContainerMobile}>
        {this.props.children &&
          <IconButton onClick={() => this.setState({drawerOpen: true})} color="primary" aria-label="Menu">
            <Icons.Drawer width={20}/>
          </IconButton>
        }
        <Drawer
          anchor="right"
          open={this.state.drawerOpen}
          onClose={() => this.setState({drawerOpen: false})}
          onClick={() => this.setState({drawerOpen: false})}
        >
          <div className={styles.mobileMenu}>
            <IconButton className="close" onClick={() => this.setState({drawerOpen: false})}>
              <Icons.Close />
            </IconButton>
            {this.props.userInfo &&
              <div className={styles.mobileUserItem}>
                {this.props.userInfo}
              </div>
            }
            {this.renderMobileItems(this)}
          </div>
        </Drawer>
      </div>
    )
  }

  renderMobileItems = (parent) => {
    if (parent.props.children) {
      return (
        <ul>
          {parent.props.children && React.Children.map(parent.props.children, navItem => {
            const active = this.matchesPath(this.props.currentPath, navItem)
            return React.cloneElement(navItem, {
              onClick: this.handleItemClick,
              active,
              mobile: true,
              children: active ? this.renderMobileItems(navItem) : undefined
            })
          })}
        </ul>
      )
    }
  }


  render = () => {
    return (
      <Fragment>
        {this.renderDesktop()}
        {this.renderMobile()}
        <div id="warning-bar"/>
      </Fragment>
    )
  }
}

const styles = StyleSheet({
  mainTabsContainer: {
    width: '650px',
    display: 'flex',
    justifyContent: 'flex-end',
    boxSizing: 'border-box',
    paddingRight: 40,
    '@media(max-width: 960px)': {
      width: '550px'
    },
    [`@media(max-width: ${MENU_COLLAPSE_AT_PX}px)`]: {
      display: 'none',
    }
  },
  mainTabs: {
    height: '80px',
    '& div': {
      borderBottom: 'none',
      height: 'inherit',
    },
    '& span': {
      color: '#FFF',
    },
  },
  subTabsContainer: {
    width: '100%',
    backgroundColor: '#f0f0f0',
    display: 'flex',
    justifyContent: 'center',
    boxSizing: 'border-box',
    [`@media(max-width: ${MENU_COLLAPSE_AT_PX}px)`]: {
      display: 'none',
    }
  },
  subTabs: {
    paddingRight: 15,
    '@media(max-width: 960px)': {
      paddingRight: 30,
    },
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: baseTheme.siteStyleguide.maxWidth,
    minHeight: 0,
    '& div': {
      borderBottom: 'none',
      justifyContent: 'flex-end',
    },
    '& span': {
      fontSize: '15px',
      backgroundColor: 'transparent',
      color: '#8aa3ac'
    },
    '& button[aria-selected="true"]': {
      '& span': {
        color: '#1B3044',
      }
    }
  },
  mainTabsContainerMobile: {
    width: '48px',
    justifyContent: 'flex-end',
    boxSizing: 'border-box',
    paddingRight: 40,
    display: 'none',
    [`@media(max-width: ${MENU_COLLAPSE_AT_PX}px)`]: {
      display: 'flex',
    }
  },
  mobileMenu: {
    position: 'relative',
    padding: [90, 20, 60, 10],
    backgroundColor: '#1B3044',
    color: '#FFF',
    width: 282,
    flex: 1,
    fontFamily: 'Montserrat,sans-serif',
    fontWeight: 'bold',
    boxSizing: 'border-box',
    '& ul': {
      boxSizing: 'border-box',
      margin: 0,
      padding: [10, 20],
    },
    '& li': {
      listStyleType: 'none',
    },
    '& a': {
      fontSize: 20,
      display: 'inline-block',
      paddingTop: 20,
      paddingBottom: 5,
      '&.active': {
        borderBottom: '5px solid #6AAEAA',
        '&:hover': {
          textDecoration: 'none',
        }
      }
    },
    '& ul ul a': {
      fontSize: 15,
      paddingTop: 15,
      paddingBottom: 5,
      color: '#8aa3ac',
      '&.active': {
        color: '#FFF',
        borderBottom: 'none',
        '&:hover': {
          textDecoration: 'none',
        }
      }
    },
    '& .close': {
      position: 'absolute',
      right: 10,
      top: 25,
    }
  },
  mobileUserItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 20,
    borderBottom: 'solid 1px rgba(255, 255, 255, 0.34)',
    paddingBottom: 15,
    '& > div': {
      margin: 0,
      '& .heading, .username': {
        textAlign: 'left'
      }
    }
  },
})

export default withRouter(Navigation)